import Vue from "vue";
import Vuex from "vuex";
import localStoragePlugin from './plugins/localStorage';

Vue.use(Vuex);

/* eslint-disable no-param-reassign */
export default new Vuex.Store({

    // Next, register the plugin using the `plugins` property on the store
    plugins: [localStoragePlugin],

    // The rest of the store remains the same..
    state: {
        version: '',
        html_home: {},
        contact: {
            name: '',
            phone: '',
            email: '',
            address: ''
        }
    },

    mutations: {

        SET_VERSION: (state, newValue) => {
            state.version = newValue;
        },

        SET_HTML_HOME: (state, newValue) => {
            state.html_home = newValue;
        },

        SET_CONTACT: (state, values) => {

            if( 'name' in values ) {
                state.contact.name = values.name ? values.name : '';
            }

            if( 'phone' in values ) {
                state.contact.phone = values.phone ? values.phone : '';
            }

            if( 'email' in values ) {
                state.contact.email = values.email ? values.email : '';
            }

            if( 'address' in values ) {
                state.contact.address = values.address ? values.address : '';
            }


        },

        // Add this mutation which allows us to load our state from the store
        initializeStore() {
            const data = localStorage ? localStorage.getItem('appState') : null;

            if (data) {
                this.replaceState(Object.assign(this.state, JSON.parse(data)));
            }
        },

    },

    actions: {

        setVersion: ({commit, state}, newValue) => {
            commit('SET_VERSION', newValue)
        },

        setHtmlHome: ({commit, state}, newValue) => {
            commit('SET_HTML_HOME', newValue)
        },

        setContactData: ({commit, state}, values) => {
            commit('SET_CONTACT', values)
        },

    }
})
